module.exports = __webpack_public_path__ + "img/img_06.7fdcabb2.jpg";